import { combineDataProviders, DataProvider, HttpError } from 'react-admin'
import publisherProvider from './concepts/Admin/providers/publisherProvider'
import vendorProvider from './concepts/Admin/providers/vendorProvider'
import affiliateProvider from './concepts/Admin/providers/affiliateProvider'
import salesProvider from './concepts/Sales/providers/salesProvider'
import earningsProvider from './concepts/Earnings/providers/earningsProvider'
import { ApolloError } from '@apollo/client'
import orgUsersProvider from './concepts/Account/providers/orgUsersProvider'
import { digitalOrdersProvider } from './concepts/Orders/providers/digitalOrdersProvider'
import physicalOrdersProvider from './concepts/Orders/providers/physicalOrdersProvider'

// HACK: The DataProvider class is not well-typed. The methods that it requires must
// more or less return any. ESLint doesn't allow explicit any, so this type alias allows
// us to sidestep that while its name (hopefully) conveys not to do this outside of this
// specific situation.
// https://github.com/marmelab/react-admin/issues/6739
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DataProviderMethodResponse = any

const providers: { [key: string]: DataProvider } = {
  sales: salesProvider,
  publishers: publisherProvider,
  vendors: vendorProvider,
  affiliates: affiliateProvider,
  'earnings/summary': earningsProvider,
  'account/manage-users': orgUsersProvider,
  'digital-orders': digitalOrdersProvider,
  'physical-orders': physicalOrdersProvider
}

export const dataProvider: DataProvider = combineDataProviders((resource) => {
  return providers[resource]
})

// This function can be assigned to the handlers on a DataProvider that we don't want to support so that it can pass type-checking.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function throwNotSupported(resource: string): Promise<any> {
  return Promise.reject(
    new HttpError(`This function is not supported for ${resource}.`, 400)
  )
}

// Use this as the last catch handler in GraphQL queries you run in a DataProvider. When a DataProvider returns a
// rejected promise with an HTTPError, React-Admin detects it and responds differently based on the error, e.g.
// retrying the query or, most crucially, logging the user out if the status is 401 Forbidden.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function convertApolloErrors(error: ApolloError): Promise<any> {
  const networkError = error.networkError
  if (networkError && 'statusCode' in networkError) {
    return Promise.reject(
      new HttpError(networkError.message, networkError.statusCode)
    )
  }

  return Promise.reject(new HttpError(error.message, 200, error))
}
